import { render, staticRenderFns } from "./HoldBalanceDialog.vue?vue&type=template&id=8f895d7e&scoped=true"
import script from "./HoldBalanceDialog.vue?vue&type=script&lang=js"
export * from "./HoldBalanceDialog.vue?vue&type=script&lang=js"
import style0 from "./HoldBalanceDialog.vue?vue&type=style&index=0&id=8f895d7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f895d7e",
  null
  
)

export default component.exports